import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Calendar
import calendar from "./calendar/reducer";

// Authentication
import login from "./auth/login/reducer";
import profile from "./auth/profile/reducer";
import account from "./auth/register/reducer";
import companyReducer from "./companyStore/reducers";
import sequenceReducer from "./sequence/sequenceReducer";

import procedure from "./modifJson/procedureReducer";
import jsonReducer from "./jsonSlice";
import jsonLearnReducer from "./jsonSliceLearn";

const rootReducer = combineReducers({
  // public
  Layout,
  calendar,
  login,
  profile,
  account,
  company: companyReducer,
  sequence: sequenceReducer,
  procedure,
  json: jsonReducer,
  jsonLearn: jsonLearnReducer,
});

export default rootReducer;



//Creators : Florian Cohen-Joly @3DDGAMES -- Under license